"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.blockToHtml = blockToHtml;
exports.getEmojis = getEmojis;
exports.initializeFromPlugin = initializeFromPlugin;
exports.matchEmoji = matchEmoji;
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _startsWith = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/starts-with"));
var _endsWith = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/ends-with"));
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _lodash = require("lodash");
var _state = _interopRequireDefault(require("@/libs/state"));
var cachedEmojiList = Object.create(null);
function initializeFromPlugin() {
  var state = (0, _state.default)();
  var emojiLocation = state.setting('emojiLocation') || '';
  var nextEmojiList = Object.create(null);
  if (typeof window !== 'undefined' && window.emojione && window.emojione.emojioneList) {
    var emojioneList = window.emojione.emojioneList;
    (0, _keys.default)(emojioneList).forEach(function (key) {
      var emoji = emojioneList[key];
      if (emoji.shortnames && emoji.shortnames.length) {
        var _context;
        var shortname = emoji.shortnames[0].replace(/:/g, '');
        nextEmojiList[shortname] = {
          code: emoji.uc_base,
          url: (0, _concat.default)(_context = "".concat(emojiLocation)).call(_context, emoji.uc_base, ".png")
        };
      }
    });
  }
  var configEmojis = state.getSetting('settings.emojis') || {};
  (0, _keys.default)(configEmojis).forEach(function (key) {
    var _context2;
    var fileName = configEmojis[key];
    nextEmojiList[key] = {
      code: fileName,
      url: (0, _concat.default)(_context2 = "".concat(emojiLocation)).call(_context2, fileName)
    };
  });
  cachedEmojiList = nextEmojiList;
}
function getEmojiByShortname(shortname) {
  return cachedEmojiList[shortname] || null;
}
function getFlagUrl(countryCode) {
  var code = String(countryCode || '').toLowerCase();
  return "https://flagcdn.com/32x24/".concat(code, ".png");
}
function getFlagEmoji(countryCode) {
  var code = String(countryCode || '').toLowerCase();
  if (typeof window !== 'undefined' && window.emojione && window.emojione.shortnameToUnicode) {
    var flagShortname = ":flag-".concat(code, ":");
    var unicodeFlag = window.emojione.shortnameToUnicode(flagShortname);
    if (unicodeFlag) {
      return {
        type: 'unicode',
        value: unicodeFlag
      };
    }
  }
  return {
    type: 'image',
    value: getFlagUrl(code),
    alt: "Flag of ".concat(code.toUpperCase())
  };
}
function matchEmoji(word) {
  if (!word) {
    return false;
  }
  if ((0, _startsWith.default)(word).call(word, ':') && (0, _endsWith.default)(word).call(word, ':')) {
    var emojiName = (0, _slice.default)(word).call(word, 1, -1);
    if ((0, _startsWith.default)(emojiName).call(emojiName, 'flag-')) {
      var countryCode = (0, _slice.default)(emojiName).call(emojiName, 5);
      var flagEmoji = getFlagEmoji(countryCode);
      return [{
        index: 0,
        match: word,
        type: 'emoji',
        meta: {
          emoji: flagEmoji.value,
          emojiType: flagEmoji.type,
          flagCode: countryCode,
          shortname: emojiName
        }
      }];
    }
    var emoji = getEmojiByShortname(emojiName);
    if (emoji) {
      return [{
        index: 0,
        match: word,
        type: 'emoji',
        meta: {
          emoji: emoji.code,
          emojiType: 'image',
          shortname: emojiName
        }
      }];
    }
  }
  var emojis = this.getEmojis(word);
  if (!emojis.length) {
    return false;
  }
  return [{
    index: 0,
    match: word,
    type: 'emoji',
    meta: {
      emoji: emojis[0].code,
      emojiType: 'image'
    }
  }];
}
function blockToHtml(block, isSingle, showEmoticons) {
  var _context3, _context1, _context10, _context11, _context12, _context13, _context14;
  if (!showEmoticons) {
    return block.content;
  }
  var emojiLocation = (0, _state.default)().setting('emojiLocation') || '';
  var emoji = block.meta.emoji;
  var emojiType = block.meta.emojiType;
  var classes = "kiwi-messagelist-emoji".concat(isSingle ? ' kiwi-messagelist-emoji--single' : '');
  if (block.meta.shortname && (0, _startsWith.default)(_context3 = block.meta.shortname).call(_context3, 'flag-')) {
    var _context4, _context7, _context8, _context9, _context0;
    var countryCode = block.meta.flagCode || (0, _slice.default)(_context4 = block.meta.shortname).call(_context4, 5);
    if (emojiType === 'unicode' && emoji && emoji.length > 1) {
      var _context5, _context6;
      return (0, _concat.default)(_context5 = (0, _concat.default)(_context6 = "<span class=\"".concat(classes, "\" style=\"font-size: ")).call(_context6, isSingle ? '24px' : '16px', "\">")).call(_context5, emoji, "</span>");
    }
    var flagUrl = getFlagUrl(countryCode);
    var altText = "Flag of ".concat(countryCode.toUpperCase());
    var size = isSingle ? '48' : '24';
    return (0, _concat.default)(_context7 = (0, _concat.default)(_context8 = (0, _concat.default)(_context9 = (0, _concat.default)(_context0 = "<img class=\"".concat(classes, "\" src=\"")).call(_context0, flagUrl, "\" alt=\"")).call(_context9, altText, "\" title=\"")).call(_context8, altText, "\" style=\"width: ")).call(_context7, size, "px; height: auto;\" />");
  }
  var isGif = emoji && (0, _endsWith.default)(_context1 = emoji.toLowerCase()).call(_context1, '.gif');
  var src = (0, _concat.default)(_context10 = "".concat(emojiLocation)).call(_context10, emoji);
  var cacheBuster = isGif ? "?t=".concat(Date.now()) : '';
  var finalSrc = src + cacheBuster;
  return (0, _concat.default)(_context11 = (0, _concat.default)(_context12 = (0, _concat.default)(_context13 = (0, _concat.default)(_context14 = "<img class=\"".concat(classes, "\" src=\"")).call(_context14, finalSrc, "\" alt=\"")).call(_context13, (0, _lodash.escape)(block.content), "\" title=\"")).call(_context12, (0, _lodash.escape)(block.content), "\"")).call(_context11, isGif ? ' loading="eager"' : '', " />");
}
function getEmojis(word) {
  var emojiLocation = (0, _state.default)().setting('emojiLocation') || '';
  var emojiList = (0, _state.default)().setting('emojis') || {};
  if (Object.prototype.hasOwnProperty.call(cachedEmojiList, word)) {
    var _context15;
    var emoji = cachedEmojiList[word];
    return [{
      ascii: word,
      code: emoji.code,
      url: emoji.url || (0, _concat.default)(_context15 = "".concat(emojiLocation)).call(_context15, emoji.code)
    }];
  }
  if (Object.prototype.hasOwnProperty.call(emojiList, word)) {
    return [{
      ascii: word,
      code: emojiList[word],
      url: emojiLocation + emojiList[word]
    }];
  }
  return [];
}
if (typeof window !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeFromPlugin);
  } else {
    setTimeout(initializeFromPlugin, 100);
  }
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["EmojiProvider"]
window._kiwi_exports.libs.EmojiProvider = exports.default ? exports.default : exports;
